import { getDepartments } from '@frontend/shared/department/data-access/src';
import { getKiosks } from '@frontend/shared/kiosk/data-access/src';
import { getSites } from '@frontend/shared/site/data-access/src';
import { createSelector } from '@ngrx/store';

export const getKioskWorkflowIds = createSelector(
  getKiosks,
  (kiosks: any[]) =>
    kiosks.map((kiosk) => [
          ...kiosk.checkin_workflow_ids,
          ...kiosk.checkout_workflow_ids,
        ])[0]
);

export const getKioskDepartmentId = createSelector(
  getDepartments,
  (departments: any[]) => departments.map((department: any) => department.id)[0]
);

export const getKioskSiteId = createSelector(
  getSites,
  (sites: any[]) => sites.map((site: any) => site.id)[0]
);
